import React from 'react'

const PaginationLeftArrow = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      // d="M629.664101,1160.49615 L633.927066,1166.8906 C634.539771,1167.80966 634.291424,1169.0514 633.372366,1169.6641 C633.043831,1169.88312 632.657816,1170 632.262966,1170 L623.737034,1170 C622.632465,1170 621.737034,1169.10457 621.737034,1168 C621.737034,1167.60515 621.85391,1167.21913 622.072934,1166.8906 L626.335899,1160.49615 C626.948604,1159.57709 628.190343,1159.32875 629.1094,1159.94145 C629.329105,1160.08792 629.517631,1160.27645 629.664101,1160.49615 Z"
      d="M1.496 5.336l6.395-4.263A2 2 0 0111 2.737v8.526a2 2 0 01-3.11 1.664L1.497 8.664a2 2 0 010-3.328z"
      fill="#41AADA"
      fillRule="evenodd"
    />
  </svg>
)

export default PaginationLeftArrow